<ng-container #dynamicLayout></ng-container>